'use client';
import { useEffect, useState } from 'react';

import { breakpoints } from '@styles/breakpoint';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const condition = breakpoints.tablet.replace('@media ', '');
      const mediaQuery = window.matchMedia(condition);
      setIsMobile(mediaQuery.matches);

      const listener = () => {
        setIsMobile(mediaQuery.matches);
      };
      mediaQuery.addEventListener('change', listener);

      return () => {
        mediaQuery.removeEventListener('change', listener);
      };
    }
  }, []);

  return isMobile;
};